import axios from 'shared/libs/axios';
import { supportPblancParamType } from '~/service/Model';

export default (params: supportPblancParamType) => {
  // 빈 값(빈 문자열, undefined, null) 파라미터 제거
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== '' && v !== undefined && v !== null)
  );
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/support-pblanc`,
    params: filteredParams
  });
}

// 조회수 증가 API
export const fetchSupportPblancRdcntUpdate = (pblancId: string) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/support-pblanc/${pblancId}`,
  });
};

// 상세 조회 API(미사용)
export const fetchSupportPblancDetail = (pblancId: string) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/support-pblanc/${pblancId}`,
  });
};

// 파일다운로드(단건)
export const fetchDownloadFile = async (pblancId: string, atchmnflSetupId: string) => {
  const url = `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/support-pblanc/${pblancId}/atchmnfl/${atchmnflSetupId}`;
  const response = await axios({
    method: 'get',
    url,
    responseType: 'blob',
  });

  // 파일명 추출 (헤더에서 또는 기본값)
  let fileName = 'downloaded-file';
  const disposition = response.headers['content-disposition'];
  if (disposition && disposition.indexOf('filename=') !== -1) {
    fileName = decodeURIComponent(disposition.split('filename=')[1].replace(/"/g, ''));
  }

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

// 파일다운로드(전체)
export const fetchAllDownloadFile = (pblancId: string) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/support-pblanc/${pblancId}/atchmnfl`,
  });
};
